import TransiVideo from "./transition-videos/TransiVideo";
import AOS from 'aos';
import 'aos/dist/aos.css'

export default class Site{
    constructor() {
        /**
         *
         * @type {Site}
         */
        let me = this;
        this.transiVideo=new TransiVideo();
        this.transiVideo.onEnded=function(){
            PovHistory.readyToinject = true;
        };
        me._initListeners();
        //---------------------go------------------------------------------
        me.resizeStage();
        me.onDomChange();
        Site.navActive();
    }

    /**
     *
     * @private
     */
    _initListeners() {

        let me=this;

        Site.initAos();
        AOS.init(
            {
                offset: 50, // offset (in px) from the original trigger point
                delay: 0, // values from 0 to 3000, with step 50ms
                duration: 600, // values from 0 to 3000, with step 50ms,
                ease:"ease-out-back",
                once: false,
                //mirror: true
            }
        );

        require("./layout/NavMenu");
        NavMenu.__init();
        require("./components/data-zoom-img");
        require("./components/data-is-lang");
        //require("./blocks/FormContact");
        //FormContact.initFromDom();

        //ferme le menu quand on change d'url
        $body.on(EVENTS.HISTORY_CHANGE_URL,function(){

            $body.attr("data-page-transition-state","start");
            //stope en attendant que la transition soit finie
            PovHistory.readyToinject=false;
            me.transiVideo.play();

            NavMenu.close();
            AOS.refresh();
        });




        //changement d'url et HTML injecté
        $body.on(EVENTS.HISTORY_CHANGE_URL_LOADED_INJECTED,function(){
            $body.attr("data-page-transition-state","end");
            me.onDomChange();
            //scroll top
            $(window).scrollTop(0);
            Site.navActive();
            me.transiVideo.preloadNext();

            Site.initAos();

            if(typeof gtag !== 'undefined' && LayoutVars.googleAnalyticsId){
                //hit google analytics
                gtag('config', LayoutVars.googleAnalyticsId, {'page_path': location.pathname});
            }

            //debug instagram embed loading
            me.debugInsta();




        });

        STAGE.on(EVENTS.RESIZE,function(){
            me.resizeStage();
        });
        $body.on(Pov.events.DOM_CHANGE,function(){
            me.onDomChange();
        });



    }

    /**
     * Selectionne / déselectionne l'item de nav de la page en cours
     */
    static navActive(){
        $("[data-href-uid]").removeClass("active");
        $("[data-href-uid='"+PovHistory.currentPageInfo.uid+"']").addClass("active");
    }

    static initAos(){
        $("[data-aos-children]").not("[data-aos-children-init]").each(function(){
            let $container=$(this);
            $container.attr("data-aos-children-init","1");
            let selector=$container.attr("data-aos-children-selector");
            let prop=$container.attr("data-aos-children");
            let delay=0;
            let lastY=$container.offset().top;
            $container.find(selector).each(function(){
                delay+=100;
                let newY=$(this).offset().top;
                if(lastY !== newY){
                    delay=0;
                }
                lastY=newY;
                $(this).attr("data-aos",prop);
                $(this).attr("data-aos-delay",delay);
            })
        })
    }


    debugInsta(){
        //debug instagram embed loading
        try{
            window.instgrm.Embeds.process();
        }catch(e){
            console.warn("insta err",e);
        }
    }

    /**
     * Adapte des élements à l'écran
     */
    resizeStage(){
        //ou pas :)
    }

    /**
     * Initialisations d'objets dom
     */
    onDomChange(){
        let me=this;
        //ou pas :)
        let i=0;
        $("[ajax-on-scroll='']").each(function(){
            let $toLoad=$(this);
            $toLoad.attr("ajax-on-scroll","init");
            i++;
            setTimeout(function(){
                $toLoad.povRefresh();
                $toLoad.attr("ajax-on-scroll","loading");
                setTimeout(function(){
                   me.debugInsta();
                },1000)
            },i*1000)

        })
    }
}


// WEBPACK FOOTER //
// ./project/_src/Site.js